import gsap from 'gsap';

export default class CardThreeD {
  /**
   * Méthode constructeur
   * @param {HTMLElement} element - Élément HTML sur lequel la composante est instanciée
   */
  constructor(element) {
    this.element = element;
    this.rotateIntensity = 5;
    this.mediaIntensity = 6;

    this.init();
  }

  init() {
    this.setRotateX = gsap.quickSetter(this.element, '--rotateX', 'deg');
    this.setRotateY = gsap.quickSetter(this.element, '--rotateY', 'deg');
    gsap.set(this.element, { '--rotateX': 0, '--rotateY': 0 });

    this.setMediaX = gsap.quickSetter(this.element, '--mediaX', 'px');
    this.setMediaY = gsap.quickSetter(this.element, '--mediaY', 'px');
    gsap.set(this.element, { '--mediaX': 0, '--mediaY': 0 });

    this.element.addEventListener('mousemove', this.onMove.bind(this));
    this.element.addEventListener('mouseleave', this.onLeave.bind(this));
  }

  onMove(e) {
    const rect = this.element.getBoundingClientRect();

    let x = (e.clientX - rect.left) / rect.width;
    let y = (e.clientY - rect.top) / rect.height;

    let normX = x * 2 - 1;
    let normY = y * 2 - 1;
    console.log(normX);
    let rotateY = -normX * this.rotateIntensity;
    let rotateX = normY * this.rotateIntensity;

    this.setRotateX(rotateX);
    this.setRotateY(rotateY);

    this.setMediaX(-normX * this.mediaIntensity);
    this.setMediaY(-normY * this.mediaIntensity);
  }

  onLeave() {
    gsap.to(this.element, {
      '--rotateX': 0,
      '--rotateY': 0,
      '--mediaX': 0,
      '--mediaY': 0,
      duration: 1.2,
      ease: 'elastic.out(1, 0.4)',
    });
  }
}
